// const BASE_URL = "http://testv2.acegear.com";
// const BASE_URL = "https://api2.acegear.cn";
const BASE_URL3 = 'https://cloud.acegear.com'
const BSSE_URL2 = "https://api2.acegear.cn"
const BASE_URL = '/api'
export default {
    videoClub: BSSE_URL2 + "/clubs/recommend/videoclub",
    hotClubs: BASE_URL3 + "/app/organization/auth/club/page",
    // focusPosts: BASE_URL + "/posts/focus",
    focusPosts: BSSE_URL2 + "/daily/today",

    postInfo: postId => `${BASE_URL}/posts/${postId}`,
    postComments: postId => `${BASE_URL}/posts/${postId}/comments`,
    userPosts: userId => `${BASE_URL}/users/${userId}/posts`,
    userInfo: userId => `${BASE_URL}/users/${userId}`
}
